import React, { Component, Fragment } from 'react';
import {message } from 'antd';
import i18n from "../../../../../../constants/initLng";
import Input from '../../../../common/component/Input';
import TextArea from '../../../../common/component/TextArea';
import * as HMS from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import './style.less';
import { DETAIL_ACTIONS } from '../../../../../../constants/Define';

export default class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { loading, roomType, validation, action } = this.props;
        return (
            <div className="basic-info">
                <div className="basic-info-box">
                    <h3>{i18n.t(`item.roomType.basic_info`)}</h3>
                    <fieldset disabled={loading}>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={roomType.code}
                                validation={validation.code}
                                labelTitle={i18n.t(`item.roomType.code`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                            <Input onChange={this.props.onChange} name={`code`}  value={roomType.code} disabled={loading} placeholder={i18n.t('item.roomType.code')} autoFocus/>
                        
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={roomType.name}
                                validation={validation.name}
                                labelTitle={i18n.t(`item.roomType.name`)}
                            >
                                <Input onChange={this.props.onChange} name={`name`} value={roomType.name} disabled={loading} placeholder={i18n.t('item.roomType.name')} />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-md-6'>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={false}
                                        isValidation={false}
                                        labelTitle={i18n.t(`item.roomType.hardblock`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input
                                            onChange={this.props.onChange}
                                            name={`hardblock`}
                                            value={Func.formatMoney(Func.checkUndefine(roomType.hardblock))}
                                            disabled={loading}
                                            placeholder={i18n.t('item.roomType.hardblock')}
                                        />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className='col-md-6'>
                                    <HMS.FormWrapperInputComponent
                                        isRequired={false}
                                        isValidation={false}
                                        labelTitle={i18n.t(`item.roomType.maxOccupancy`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input
                                            onChange={this.props.onChange}
                                            name={`maxOccupancy`}
                                            value={Func.formatMoney(Func.checkUndefine(roomType.maxOccupancy))}
                                            disabled={loading}
                                            placeholder={i18n.t('item.roomType.maxOccupancy')}
                                        />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.shortDescription`)}
                            >
                                <TextArea onChange={this.props.onChange} name={`shortDescription`}  value={roomType.shortDescription} disabled={loading} placeholder={i18n.t('item.roomType.shortDescription')} />
                            </HMS.FormWrapperInputComponent>
                        </div>

                        <div className="form-group">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.description`)}
                            >
                                <TextArea onChange={this.props.onChange} name={`description`} value={roomType.description} disabled={loading} placeholder={i18n.t('item.roomType.description')} />
                            </HMS.FormWrapperInputComponent>
                        </div>
                    </fieldset>
                </div>
            </div>
        );
    }
}

